import { frontendURL } from '../../../../helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import AppointmentsIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/appointments'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return {
              name: 'appointments_settings',
              params: to.params,
            };
          },
        },
        {
          path: 'settings',
          name: 'appointments_settings',
          meta: {
            permissions: [...ROLES],
          },
          component: AppointmentsIndex,
        },
      ],
    },
  ],
};
